import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "./AuthenticationAndSigningPage.scss";
import fcAuthenticationAndSigning from "../../assets/images/banner-authentication-and-signing.png";
import Copyright from "../../components/Copyright/Copyright";

const AuthenticationAndSigningPage = () => {
  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="feature-page">
      {/* Hero Section */}
      <section className="feature-hero">
        <div className="container">
          <div className="feature-hero-image">
            <img src={fcAuthenticationAndSigning} alt="Authentication and Signing" />
          </div>
        </div>
      </section>

      {/* Authentication and Signing Information */}
      <section className="feature-info">
        <div className="container">
          <div className="feature-grid">
            <div className="feature-details">
              <h2>Authentication and signing solutions</h2>
              <p>
                CashManager provides secure authentication and digital signing capabilities that ensure 
                the highest level of security for your financial transactions and document management.
              </p>

              <div className="feature-methods three-columns">
                <div className="feature-method">
                  <div className="method-content">
                    <h3>Smart-ID integration</h3>
                    <p>Seamless integration with Smart-ID for secure authentication and digital signing across all Baltic countries and Belgium.</p>
                  </div>
                </div>

                <div className="feature-method">
                  <div className="method-content">
                    <h3>eParaksts support</h3>
                    <p>Full support for Latvian eParaksts (eSignature) system for legally binding digital signatures (.edoc, .asice).</p>
                  </div>
                </div>

                <div className="feature-method">
                  <div className="method-content">
                    <h3>National ID cards support</h3>
                    <p>Full support for Estonian, Latvian and Lithuanian national ID cards for authentication and digital signing.</p>
                  </div>
                </div>

              </div>
            </div>

            <div className="feature-features">
              <h2>Key features</h2>
              
              <div className="features-list">
                <div className="feature-item">
                  <h3>Multi-factor authentication</h3>
                  <p>Enhanced security with multiple authentication factors including biometric verification.</p>
                </div>

                <div className="feature-item">
                  <h3>Digital document signing</h3>
                  <p>Sign contracts, invoices, and financial documents with legally binding digital signatures.</p>
                </div>

                <div className="feature-item">
                  <h3>Payment authorization</h3>
                  <p>Secure payment authorization with real-time verification and fraud prevention.</p>
                </div>

                <div className="feature-item">
                  <h3>Audit trail</h3>
                  <p>Comprehensive logging of all authentication and signing activities for compliance and security.</p>
                </div>

                <div className="feature-item">
                  <h3>Cross-platform support</h3>
                  <p>Works seamlessly across desktop, mobile, and web platforms with consistent security standards.</p>
                </div>

                <div className="feature-item">
                  <h3>Regulatory compliance</h3>
                  <p>Full compliance with eIDAS regulation and local digital signature requirements.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Implementation Process */}
      <section className="implementation-process">
        <div className="container">
          <div className="section-header">
            <h2>Implementation process</h2>
            <p>Get started with secure authentication and signing in just a few simple steps</p>
          </div>

          <div className="process-steps">
            <div className="process-step">
              <div className="step-number">1</div>
              <div className="step-content">
                <h3>Security assessment</h3>
                <p>We evaluate your current security requirements and recommend the best authentication solutions.</p>
              </div>
            </div>

            <div className="process-step">
              <div className="step-number">2</div>
              <div className="step-content">
                <h3>Service integration</h3>
                <p>Configure and integrate the selected authentication and signing services with your system.</p>
              </div>
            </div>

            <div className="process-step">
              <div className="step-number">3</div>
              <div className="step-content">
                <h3>Testing & validation</h3>
                <p>Comprehensive testing of authentication flows and digital signature validation processes.</p>
              </div>
            </div>

            <div className="process-step">
              <div className="step-number">4</div>
              <div className="step-content">
                <h3>Deployment & training</h3>
                <p>Deploy to production with user training and ongoing security monitoring and support.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to secure your financial operations?</h2>
            <p>Contact our team to discuss your authentication and signing requirements and implement the most secure solution for your business.</p>
            <Link to="/onboarding" className="btn btn-secondary btn-large">Get started</Link>
          </div>
        </div>
      </section>

      {/* Copyright Section */}
      <Copyright />
    </div>
  );
};

export default AuthenticationAndSigningPage;
